export const sortStringsCaseInsensitive = (strings: string[] | undefined): string[] => {
  return strings?.slice().sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" })) ?? [];
};
